import { ArrowLeft, Text } from '@doda/io-react/common';
import type { ScoutJobDetailResponse } from '@doda/api-client/aspida/@types';
import styles from './index.module.scss';

interface MessageLinkProps {
  scoutMessage: ScoutJobDetailResponse['scoutMessage'];
  position: 'Header' | 'Footer';
}

export const MessageLink = ({ scoutMessage, position }: MessageLinkProps) => {
  const isSaiyoProject = scoutMessage?.wdispfl === '1';
  // 分析用要素ID生成
  const id = `messageDetailUrlTab${position}-${isSaiyoProject ? 'saiyo' : 'offer'}`;

  return (
    <a
      id={id}
      href={scoutMessage?.url}
      className={styles['jobSearchDetail-messageLink']}
    >
      <ArrowLeft color="blue" size="XS" />
      <Text color="blue" size="12" weight="normal" as="span">
        {isSaiyoProject ? 'スカウトメッセージへ' : 'オファーメッセージへ'}
      </Text>
    </a>
  );
};
